import type { SVGProps } from "react";
export interface Parcel02SearchIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Parcel02SearchIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Parcel02SearchIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 11.66V8.413l-6.75 3.75v7.6a1.124 1.124 0 0 1 .123 2.172 4.13 4.13 0 0 1-2.993-.193l-.234-.12-6-3.279a4.13 4.13 0 0 1-2.146-3.62V8.28c0-.704.182-1.381.508-1.978a1.1 1.1 0 0 1 .17-.285A4.1 4.1 0 0 1 3.021 4.66l2.97-1.624.049-.026 2.981-1.63.234-.118a4.13 4.13 0 0 1 3.724.119l6 3.28.242.143c.5.319.915.738 1.23 1.222a1.1 1.1 0 0 1 .166.276c.326.597.508 1.274.508 1.978v3.38a1.125 1.125 0 0 1-2.25 0M4.329 6.51 11 10.214l2.185-1.215-6.653-3.694L4.33 6.509Zm7.57-3.154a1.88 1.88 0 0 0-1.583-.1l-.215.1-1.235.674 6.636 3.684 2.167-1.204zM3.125 14.722c0 .686.374 1.317.976 1.645l5.774 3.156v-7.361l-6.75-3.75z"
      />
      <path
        fill={color}
        d="M20.375 18.5a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0M4.017 12.953a1.124 1.124 0 0 1 1.425-.488l.104.051 3 1.666.099.061A1.126 1.126 0 0 1 7.558 16.2l-.104-.05-3-1.668-.099-.06a1.125 1.125 0 0 1-.338-1.47ZM22.625 18.5c0 .73-.193 1.413-.526 2.008l.696.696.078.085a1.125 1.125 0 0 1-1.582 1.583l-.087-.077-.696-.696a4.1 4.1 0 0 1-2.008.526 4.125 4.125 0 1 1 4.125-4.125"
      />
    </svg>
  );
}
